import { render, staticRenderFns } from "./BulkQuickActions.vue?vue&type=template&id=f512e116&scoped=true"
import script from "./BulkQuickActions.vue?vue&type=script&lang=js"
export * from "./BulkQuickActions.vue?vue&type=script&lang=js"
import style0 from "./BulkQuickActions.vue?vue&type=style&index=0&id=f512e116&prod&lang=scss"
import style1 from "./BulkQuickActions.vue?vue&type=style&index=1&id=f512e116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512e116",
  null
  
)

export default component.exports